"use strict";
var CountryViewModel = (function () {
    function CountryViewModel() {
        this.isoCode2 = '';
        this.name = '';
    }
    return CountryViewModel;
}());
exports.CountryViewModel = CountryViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/country-view.model.js